import gql from 'graphql-tag'

const MERGE_TICKETS = gql`
  mutation mergeTickets ($baseTicket: String!, $mergeTicket: String!) {
    mergeTickets (baseTicket: $baseTicket, mergeTicket: $mergeTicket)
  }
`

export { MERGE_TICKETS }
